import { AnyStyledComponent } from 'styled-components'
import React, { FC, memo, MouseEvent, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { encodeToBase64 } from '../../../../../utils/encoding-utils'
import { Container, Icon, Input, Label, Text } from './checkbox-radio-filter-styles'
import { FilterItemTransport } from '../../../../../transports/filters-configuration-transport'
import { FilterType } from '../../types'
import { filterGATracking, preventEvent } from '../../utils'
import { filterClick, getRegionNodeId } from '../../../../../redux/filters'

import { Dispatch } from '../../../../../redux/types'
import { useRequestUserConfigContext } from '../../../../../hooks/request'

import RadioSelectedIcon from '../../../../../assets/icons/filter-icons/radio-selected.svg'

type Props = {
    onFilterItemClick: (selectedFilterItemPosition: any) => void
    filterItem: FilterItemTransport
    filterItemPosition: number
    filterType: FilterType
    isFilterItemSelected: boolean
    shouldCommit?: boolean
}

const RadioFilterItem: FC<Props> = ({
    onFilterItemClick,
    filterItem,
    filterItemPosition,
    filterType,
    isFilterItemSelected,
    shouldCommit = false,
}) => {
    const dispatch = useDispatch<Dispatch>()
    const regionNodeId = useSelector(getRegionNodeId)
    const user = useRequestUserConfigContext()

    const handleClick = useCallback(
        (event: MouseEvent<HTMLLabelElement>) => {
            preventEvent(event)
            filterGATracking({
                type: filterType,
                name: filterItem.title,
                value: filterItem.value,
                isChecked: !isFilterItemSelected,
                regionNodeId,
            })
            onFilterItemClick(filterItemPosition)
            const filterItemUrl = new URL(filterItem.absoluteLink)
            dispatch(filterClick(encodeToBase64(filterItemUrl.pathname + filterItemUrl.search), shouldCommit, user))
        },
        [
            onFilterItemClick,
            filterItemPosition,
            filterItem,
            filterType,
            isFilterItemSelected,
            dispatch,
            regionNodeId,
            shouldCommit,
            user,
        ],
    )

    return (
        <Container isMultiSelect={false} $disabled={filterItem.count < 1}>
            <Text>{filterItem.title}</Text>
            <Label onClick={handleClick} checked={isFilterItemSelected} isMultiSelect={false}>
                {isFilterItemSelected && (
                    <Icon type="radio" as={RadioSelectedIcon as AnyStyledComponent} alt="radio selector" />
                )}
                <Input type="radio" name={filterType} defaultChecked={isFilterItemSelected} />
            </Label>
        </Container>
    )
}

export default memo(RadioFilterItem)
